<script setup lang="ts">
import { useRolesStore } from "@/stores/roles";
import { ref, toRefs, computed } from "vue";
const props = defineProps<{
  cs?: boolean;
}>();
const { cs } = toRefs(props);

const roleStore = useRolesStore();

const email = ref("");
const role = ref("");
const roles = computed(() => {
  return cs.value
    ? ["", "cs", "csadm"]
    : [
        "",
        "stralfors",
        "dev",
        "image",
        "cs",
        "csadm",
        "security",
        "newsletter",
      ];
});
const result = ref("");
const error = ref("");
const working = ref(false);
const upload = async () => {
  error.value = "";
  working.value = true;
  email.value = email.value.trim().toLowerCase();
  const emailvalidation = /@(postnord\.com|stralfors\.se)$/;
  if (!emailvalidation.test(email.value)) {
    error.value = "invalid email";
  }
  const r = await roleStore.updateRole(email.value, role.value, true);
  if (r.result === "created" || r.result === "ok") {
    result.value = "success";
  } else {
    result.value = "error";
  }
  working.value = false;
};
</script>

<template>
  <h3>Add or update email/role</h3>
  <pn-input label="User email" v-model="email" />
  <p v-show="error">
    <pn-toast closable="false" appearance="error">
      {{ error }}
    </pn-toast>
  </p>
  <p>
    Role:
    <select v-model="role">
      <option v-for="r in roles" :key="r" :value="r">{{ r }}</option>
    </select>
  </p>
  <pn-button @click="upload" :loading="working">Add</pn-button>
  <p v-show="result">
    <pn-toast
      v-show="result === 'success'"
      closable="false"
      text="Success"
    ></pn-toast>
    <pn-toast
      v-show="result !== 'success'"
      closable="false"
      appearance="error"
      :text="result"
    ></pn-toast>
  </p>
</template>

<style lang="scss" scoped></style>
